import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {Range} from '../../../../../../../common/api/range';
import {TranslateManager} from '../../../../../../../common/translate';
import {isNullOrUndefined} from 'util';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'tfl-range-radio-group',
    template: require('./range-radio-group.component.html'),
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RangeRadioGroupComponent),
            multi: true
        }
    ]
})
export class RangeRadioGroupComponent implements ControlValueAccessor {

    @Output() change = new EventEmitter();
    @Input() isEdited: boolean;
    @Input() ranges: Array<Range>;
    @Input() translatePath: string;
    @Input() rangeUnit: string;
    @Input() title: string;
    @Input() controlName: string;

    constructor(private _translateManager: TranslateManager) {
    }

    private _value: any;

    get value(): any {
        return this._value;
    }

    set value(value: any) {
        this._value = value;
        this.propagateChange(this._value);
    }

    propagateChange = (_: any) => {
    };

    getRangeLabel(rangeId: number): string {
        if (rangeId !== 9999) {
            if (isNullOrUndefined(this.ranges) || isNullOrUndefined(rangeId)) {
                return '';
            }
            if (isNullOrUndefined(rangeId)) return '';
            let selectedRange = this.ranges.find(range => range.id === rangeId);
            if (isNullOrUndefined(selectedRange)) return '';
            let rangeType = isNullOrUndefined(selectedRange.from) ? 'UP' : isNullOrUndefined(selectedRange.to) ? 'MORE' : 'FROM_TO';
            return this._translateManager.getValue(`${this.translatePath}.${rangeType}`, {
                amountFrom: selectedRange.from,
                amountTo: selectedRange.to,
                unit: this.rangeUnit
            });
        }

    }

    writeValue(value: any): void {
        if (value != this.value) {
            this.value = value;
        }
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/range-radio-group/range-radio-group.component.ts